import { Button, ButtonGroup, FormCheck } from 'react-bootstrap'
import { DATE_FORMATS_ORDER, DATE_FORMAT_LABELS, DateFormat, Instance, NAME_FORMATS_ORDER, NAME_FORMAT_LABELS, NameFormat } from '../models/shared/Instance';
import { useState } from 'react';

interface Props {
    instance: Instance
    autoUpdateInstance: (data: Partial<Instance>) => void
}

export const HIDE_OLDER_REVIEWS_DAYS_DEFAULT = 30;

function InstanceOptionsContent(props: Props) {
    const { autoUpdateInstance, instance } = props
    const [showOlderReviews, setShowOlderReviews] = useState(!!instance.hideReviewsOlderThanDays);

    const toggleShowOlderReviews = () => {
        setShowOlderReviews(!showOlderReviews)
        autoUpdateInstance({ hideReviewsOlderThanDays: showOlderReviews ? 0 : HIDE_OLDER_REVIEWS_DAYS_DEFAULT })
    }


    const minRating = instance.minRating || 1;
    const dateFormat: DateFormat = instance.dateFormat || 'DD/MM/YYYY';
    const nameFormat: NameFormat = instance.nameFormat || 'Full';

    return <div className='d-flex flex-column gap-2'>
        <div>

            <label>Minimal rating</label>
            <div className="mb-3 d-flex align-items-center">
                <ButtonGroup>
                    {[1, 2, 3, 4, 5].map(number => {
                        const isSelected = number === minRating;
                        return <Button size="sm" key={number}
                            onClick={() => autoUpdateInstance({ minRating: number })}
                            variant={isSelected ? 'primary' : "outline-primary"}>
                            {number}
                        </Button>
                    }
                    )}
                </ButtonGroup>
                <div className="ms-2">
                    {[1, 2, 3, 4, 5].map(number => <i key={number} className={`bi ${number <= minRating ? 'bi-star-fill' : 'bi-star'}`}
                        style={{ color: '#fbbc04' }}
                    />)}
                </div>
            </div>
        </div>

        <div>

            <label>Date format</label>
            <div className="mb-3">

                <ButtonGroup>
                    {DATE_FORMATS_ORDER.map(format => {
                        const isSelected = format === dateFormat;
                        return <Button key={format}
                            size="sm"
                            onClick={() => autoUpdateInstance({ dateFormat: format })}
                            variant={isSelected ? 'primary' : "outline-primary"}>
                            {DATE_FORMAT_LABELS[format]}
                        </Button>
                    })}
                </ButtonGroup>
            </div>
        </div>

        <div>

            <label>Reviewer name</label>
            <div className="mb-3">

                <ButtonGroup>
                    {NAME_FORMATS_ORDER.map(format => {
                        const isSelected = format === nameFormat;
                        return <Button key={format}
                            size="sm"
                            onClick={() => autoUpdateInstance({ nameFormat: format })}
                            variant={isSelected ? 'primary' : "outline-primary"}>
                            {NAME_FORMAT_LABELS[format]}
                        </Button>
                    })}
                </ButtonGroup>
            </div>
        </div>

        <FormCheck
            type="switch"
            label="Show only reviews with text"
            className="pointer"
            checked={!!instance.textOnly}
            onChange={(e) => autoUpdateInstance({ textOnly: e.target.checked })}
        />
        <FormCheck
            type="switch"
            label="Random order"
            className="pointer"
            checked={!!instance.randomOrder}
            onChange={(e) => autoUpdateInstance({ randomOrder: e.target.checked })}
        />
        <div>

            <FormCheck
                type="switch"
                label="Hide older reviews"
                className="pointer"
                checked={!!showOlderReviews}
                onChange={toggleShowOlderReviews}
            />
            {!!showOlderReviews && <div className="mb-3 d-flex align-items-center">
                <span>Hide reviews older than&nbsp;</span>
                <input type="number" className="form-control form-control-sm"
                    style={{ width: '80px' }}
                    min={1}
                    step={1}
                    value={instance.hideReviewsOlderThanDays || 0}
                    onChange={(e) => autoUpdateInstance({ hideReviewsOlderThanDays: parseInt(e.target.value) })}
                />
                <span>&nbsp;days</span>
            </div>}
        </div>
    </div>

}

export default InstanceOptionsContent
